import React from "react";

import { Icon } from "../../../components/Icon/Icon";
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { didElementTouchedTop } from "../../../lib/helpers/didElementTouchedTop";
import { useGlobalContext } from "../../../lib/context/GlobalContext/GlobalContext";

import threeProducts2 from "../../../assets/images/Infinite60x50/three-products2.png";
import office from "../../../assets/images/office.png";
import product60x50 from "../../../assets/images/Infinite60x50/60x50.png";
import product60x50Bottom from "../../../assets/images/Infinite60x50/60x50-bottom-two.png";
import qualcomm from "../../../assets/images/qualcomm-5g-sdx62.png";
import FlickitySlider from "../../../components/FlickitySlider/FlickitySlider";
import allProducts from "../../../assets/images/all-products.jpeg";
import productWallpaper from "../../../assets/images/Infinite60x50/60x50-wallpaper.png";
import wifiSixGroup from "../../../assets/images/wifiSixGroup.png";
import productCartOne from "../../../assets/images/Infinite60x50/60x50.png";
import productCartTwo from "../../../assets/images/Infinite60x50/60x50-bottom-three.png";
import productCartThree from "../../../assets/images/Infinite60x50/60x50-front.png";

import cs from "classnames";

import OtherProducts from "../OtherProducts/OtherProducts";

import "./Infinite50.scss";

const Infinite50 = () => {
  const navigate = useNavigate();
  const changeHeaderColor = useGlobalContext().changeHeaderColor;
  const [productTitleRef, productTitleVisibility] = useInView();
  const [productImageRef, productImageVisibility] = useInView();
  const [topSliderTitleRef, topSliderTitleVisibility] = useInView();
  const [topSliderRef, topSliderVisibility] = useInView();
  const [productOutlineSubTitleRef, productOutlineSubTitleVisibility] =
    useInView();
  const [productOutlineImageRef, productOutlineImageVisibility] = useInView();
  const [topTextOneRef, topTextOneVisibility] = useInView();
  const [topTextTwoRef, topTextTwoVisibility] = useInView();
  const [bottomTextOneRef, bottomTextOneVisibility] = useInView();
  const [bottomTextTwoRef, bottomTextTwoVisibility] = useInView();
  const [wifiSixImageRef, wifiSixImageVisibility] = useInView();
  const [wifiSixTitleRef, wifiSixTitleVisibility] = useInView();
  const [wifiSixCartImageRef, wifiSixCartImageVisibility] = useInView();
  const [officeHeadRef, officeHeadVisibility] = useInView();
  const [officeImageRef, officeImageVisibility] = useInView();
  const [otherProductsTitleRef, otherProductsTitleVisibility] = useInView();
  const [twoSectionRef, twoSectionVisibility] = useInView();
  const [officeRef, officeVisibility] = useInView();
  const [otherProductsRef, otherProductsVisibility] = useInView();

  didElementTouchedTop(".TwoSections50", (value) => {
    if (twoSectionVisibility) {
      if (value) {
        changeHeaderColor("black");
      } else {
        changeHeaderColor("white");
      }
    }
  });
  didElementTouchedTop(".Office50", (value) => {
    if (officeVisibility) {
      if (value) {
        changeHeaderColor("black");
      } else {
        changeHeaderColor("white");
      }
    }
  });
  didElementTouchedTop(".OtherProducts50", (value) => {
    if (otherProductsVisibility) {
      if (value) {
        changeHeaderColor("black");
      } else {
        changeHeaderColor("white");
      }
    }
  });

  return (
    <div className="InfiniteProduct50">
      <div className="ProductHeader50">
        <div className="ProductHeader50__container">
          <div className="ProductHeader50__left">
            <div
              className="ProductHeader50__products"
              onClick={() => {
                navigate("/products");
              }}
            >
              Products
            </div>
            <Icon
              className="ProductHeader50__icon"
              icon="chevron-right-black"
            />
            <div className="ProductHeader50__product">Infinite 50</div>
          </div>
          <div className="ProductHeader50__right">
            <div className="ProductHeader50__design">Design</div>
            <div className="ProductHeader50__features">Features</div>
            <div className="ProductHeader50__specifications">
              Specifications
            </div>
          </div>
        </div>
      </div>
      <div className="ProductImage50">
        <div className="ProductImage50__container">
          <div
            ref={productTitleRef}
            className={cs(
              "ProductImage50__title",
              productTitleVisibility && "ProductImage50__title-animation",
            )}
          >
            Infinite <span>50</span>
          </div>
          <img
            ref={productImageRef}
            className={cs(
              "ProductImage50__image",
              productImageVisibility && "ProductImage50__image-animation",
            )}
            src={threeProducts2}
          />
        </div>
      </div>

      <div className="TopSliderTitle50">
        <div
          ref={topSliderTitleRef}
          className={cs(
            "TopSliderTitle50__title",
            topSliderTitleVisibility && "TopSliderTitle50__title-animation",
          )}
        >
          <span>Next-Generation</span> <br /> Connectivity Made Simple
        </div>
      </div>

      <div
        ref={topSliderRef}
        className={cs(
          "TopSlider50",
          topSliderVisibility && "TopSlider50-animation",
        )}
      >
        <FlickitySlider
          options={{
            lazyLoad: 10,
            wrapAround: true,
            contain: true,
            draggable: true,
            autoPlay: true,
            freeScroll: true,
            imagesLoaded: true,
            prevNextButtons: false,
          }}
        >
          <div className="TopSlider50__section">
            <div className="TopSlider50__section-left">
              <div className="TopSlider50__section-textOne">
                Plug-and-Play Simplicity
              </div>
              <div className="TopSlider50__section-textTwo">
                The Infinite 50 revolutionizes wireless connectivity with its
                seamless integration and straightforward setup, offering a
                hassle-free user experience right out of the box.
              </div>
            </div>
            <div className="TopSlider50__section-right">
              <img
                className="TopSlider50__section-image"
                data-flickity-lazyload={productCartOne}
              />
            </div>
          </div>{" "}
          <div className="TopSlider50__section">
            <div className="TopSlider50__section-left">
              <div className="TopSlider50__section-textOne">
                Elevated Performance
              </div>
              <div className="TopSlider50__section-textTwo">
                Dive into an unprecedented realm of performance and versatility.
                Whether it's for work or play, the Infinite 50 sets new
                standards in network capability.
              </div>
            </div>
            <div className="TopSlider50__section-right">
              <img
                className="TopSlider50__section-image"
                data-flickity-lazyload={productCartOne}
              />
            </div>
          </div>{" "}
          <div className="TopSlider50__section">
            <div className="TopSlider50__section-left">
              <div className="TopSlider50__section-textOne">
                Powered by Qualcomm
              </div>
              <div className="TopSlider50__section-textTwo">
                At its core, advanced Qualcomm technology drives the Infinite
                50, guaranteeing a robust foundation for bandwidth-hungry
                applications, online gaming, and ultra-high-definition 4K video
                streaming.
              </div>
            </div>
            <div className="TopSlider50__section-right">
              <img
                className="TopSlider50__section-image"
                data-flickity-lazyload={productCartOne}
              />
            </div>
          </div>
        </FlickitySlider>
      </div>

      <div className="ProductOutline50">
        <div className="ProductOutline50__container">
          <div
            ref={productOutlineSubTitleRef}
            className={cs(
              "ProductOutline50__subtitle",
              productOutlineSubTitleVisibility &&
                "ProductOutline50__subtitle-animation",
            )}
          >
            5G technology delivers lightning-fast speeds, minimal latency, and
            increased capacity, revolutionizing wireless communication and
            enabling groundbreaking innovations across various industries.
          </div>
          <div className="ProductOutline50__body">
            <img
              ref={productOutlineImageRef}
              loading="lazy"
              className={cs(
                "ProductOutline50__image",
                productOutlineImageVisibility &&
                  "ProductOutline50__image-animation",
              )}
              src={product60x50}
            />
          </div>
        </div>
      </div>

      <div ref={twoSectionRef} className="TwoSections50">
        <div className="TwoSections50__top">
          <div className="TwoSections50__top-left">
            <img className="TwoSections50__top-left-image" src={qualcomm} />
          </div>
          <div className="TwoSections50__top-right">
            <div
              ref={topTextOneRef}
              className={cs(
                "TwoSections50__top-right-textOne",
                topTextOneVisibility &&
                  "TwoSections50__top-right-textOne-animation",
              )}
            >
              Accelerated Performance <br />
              Unwavering Stability <br /> The Qualcomm Advantage
            </div>
            <div
              ref={topTextTwoRef}
              className={cs(
                "TwoSections50__top-right-textTwo",
                topTextTwoVisibility &&
                  "TwoSections50__top-right-textTwo-animation",
              )}
            >
              Empowered by Qualcomm's SDX62 5G modem, the device delivers
              unparalleled speeds and robust reliability, elevating your digital
              world.
            </div>
          </div>
        </div>
        <div className="TwoSections50__bottom">
          <div className="TwoSections50__bottom-left">
            <div
              ref={bottomTextOneRef}
              className={cs(
                "TwoSections50__bottom-left-textOne",
                bottomTextOneVisibility &&
                  "TwoSections50__bottom-left-textOne-animation",
              )}
            >
              Sleek Sophistication <br /> Where Design Meets Innovation
            </div>
            <div
              ref={bottomTextTwoRef}
              className={cs(
                "TwoSections50__bottom-left-textTwo",
                bottomTextTwoVisibility &&
                  "TwoSections50__bottom-left-textTwo-animation",
              )}
            >
              Design marries form and function, creating technology that is both
              visually appealing and intuitively functional, enhancing everyday
              interactions for seamless experiences.
            </div>
          </div>
          <div className="TwoSections50__bottom-right">
            <img
              className="TwoSections50__bottom-right-image"
              src={product60x50Bottom}
            />
          </div>
        </div>
      </div>

      <div className="WifiSix50">
        <img
          ref={wifiSixImageRef}
          src={wifiSixGroup}
          className={cs(
            "WifiSix50__image",
            wifiSixImageVisibility && "WifiSix50__image-animation",
          )}
        />
        <div
          ref={wifiSixTitleRef}
          className={cs(
            "WifiSix50__title",
            wifiSixTitleVisibility && "WifiSix50__title-animation",
          )}
        >
          Workspace-Optimized-Connectivity <br /> The Infinite 50 Experience
        </div>
        <div className="WifiSix50__carts">
          <div className="WifiSix50__cart">
            <img src={productCartOne} className="WifiSix50__cart-image" />
            <div className="WifiSix50__cart-text">
              <div className="WifiSix50__cart-textOne">
                Workspace Integration
              </div>
              <div className="WifiSix50__cart-textTwo">
                The Infinite 50's sleek and adaptable design seamlessly blends
                into any workspace environment, enhancing both aesthetics and
                functionality.
              </div>
            </div>
          </div>
          <div className={cs("WifiSix50__cart", "WifiSix50__cart-middle")}>
            <img
              ref={wifiSixCartImageRef}
              src={productCartTwo}
              className={cs(
                "WifiSix50__cart-image",
                "WifiSix50__cart-image-middle",
                wifiSixCartImageVisibility &&
                  "WifiSix50__cart-image-middle-animation",
              )}
            />
            <div className="WifiSix50__cart-text">
              <div
                className={cs(
                  "WifiSix50__cart-textOne",
                  "WifiSix50__cart-textOne-middle",
                )}
              >
                Tailored Connectivity
              </div>
              <div
                className={cs(
                  "WifiSix50__cart-textTwo",
                  "WifiSix50__cart-textTwo-middle",
                )}
              >
                Customizable features ensure the Infinite 50 caters to the
                diverse connectivity needs of modern workspaces, offering
                versatility for both gaming and professional applications.
              </div>
            </div>
          </div>
          <div className="WifiSix50__cart">
            <img src={productCartThree} className="WifiSix50__cart-image" />
            <div className="WifiSix50__cart-text">
              <div className="WifiSix50__cart-textOne">
                Efficient Performance
              </div>
              <div className="WifiSix50__cart-textTwo">
                Engineered to excel in workspace environments, the Infinite 50
                delivers reliable connectivity and rapid response times,
                optimizing productivity and performance for users across various
                tasks.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div ref={officeRef} className="Office50">
        <div className="Office50__container">
          <div
            ref={officeHeadRef}
            className={cs(
              "Office50__head",
              officeHeadVisibility && "Office50__head-animation",
            )}
          >
            <div className="Office50__head-left">
              Unlocking Your Network's <br /> Full Potential
            </div>
            <div className="Office50__head-right">
              <div className="Office50__head-right-left">+64</div>
              <div className="Office50__head-right-right">
                Expansive Signal Reach: Harnessing the Strength of Infinite 50's
                Dual-Band Antennas for Complete Coverage and Reliable
                Connectivity
              </div>
            </div>
          </div>
          <img
            ref={officeImageRef}
            loading="lazy"
            className={cs(
              "Office50__image",
              officeImageVisibility && "Office50__image-animation",
            )}
            src={office}
          />
        </div>
      </div>

      <div className="Specifications50">
        <div className="Specifications50__container">
          <div className="Specifications50__title">Specifications</div>
          <div className="Specifications50__subtitle">Hardware</div>
          <div className="Specifications50__section">
            <div className="Specifications50__section-left">
              <div className="Specifications50__section-title">5G Chipset</div>
            </div>
            <div className="Specifications50__section-right">
              <div
                className={cs(
                  "Specifications50__section-description",
                  "Specifications50__section-description-borderNone",
                )}
              >
                5G Qualcomm SDX62
              </div>
            </div>
          </div>
          <div className="Specifications50__section">
            <div className="Specifications50__section-left">
              <div className="Specifications50__section-title">
                Wi-Fi Chipset
              </div>
            </div>
            <div className="Specifications50__section-right">
              <div className="Specifications50__section-description">
                Wi-Fi 6 Qualcomm IPQ5018 + QCN6102
              </div>{" "}
              <div className="Specifications50__section-description">
                2T2R 2.4GHz 802.11b/g/n/ac/ax, 574Mbps
              </div>
              <div className="Specifications50__section-description">
                4T4R 5.8GHz 802.11a/n/ac/ax, 2402Mbps
              </div>
              <div
                className={cs(
                  "Specifications50__section-description",
                  "Specifications50__section-description-borderNone",
                )}
              >
                3 dBi internal 2.4G&5G dual band antenna
              </div>
            </div>
          </div>

          <div className="Specifications50__section">
            <div className="Specifications50__section-left">
              <div className="Specifications50__section-title">
                Device Interfaces
              </div>
            </div>
            <div className="Specifications50__section-right">
              <div className="Specifications50__section-description">
                1 x 1Gbps LAN Ethernet
              </div>
              <div className="Specifications50__section-description">
                1 x 2.5Gbps WAN Ethernet
              </div>
              <div className="Specifications50__section-description">
                1 x Power jack
              </div>{" "}
              <div className="Specifications50__section-description">
                1 x Phone jack
              </div>
              <div
                className={cs(
                  "Specifications50__section-description",
                  "Specifications50__section-description-borderNone",
                )}
              >
                Maximum Concurrent Users – 64 Devices
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ImageSlider50">
        <FlickitySlider
          options={{
            lazyLoad: 10,
            wrapAround: true,
            contain: true,
            draggable: true,
            autoPlay: true,
            freeScroll: true,
            imagesLoaded: true,
            prevNextButtons: false,
          }}
        >
          <div className="ImageSlider50__image-container">
            <img
              loading="lazy"
              className="ImageSlider50__image"
              data-flickity-lazyload={allProducts}
            />
          </div>
          <div className="ImageSlider50__image-container">
            <img
              loading="lazy"
              className="ImageSlider50__image"
              data-flickity-lazyload={productWallpaper}
            />
          </div>
          <div className="ImageSlider50__image-container">
            <img
              loading="lazy"
              className="ImageSlider50__image"
              data-flickity-lazyload={allProducts}
            />
          </div>
          <div className="ImageSlider50__image-container">
            <img
              loading="lazy"
              className="ImageSlider50__image"
              data-flickity-lazyload={productWallpaper}
            />
          </div>
        </FlickitySlider>
      </div>

      <div ref={otherProductsRef} className="OtherProducts50">
        <div className="OtherProducts50__container">
          <div
            ref={otherProductsTitleRef}
            className={cs(
              "OtherProducts50__title",
              otherProductsTitleVisibility &&
                "OtherProducts50__title-animation",
            )}
          >
            Other Products
          </div>
          <OtherProducts />
        </div>
      </div>
    </div>
  );
};

export default Infinite50;
